import { brl, dateTime } from "./hooks";
import type { Notification } from "./types";

const text = (value: unknown) => typeof value === "string" ? value : "";
const civilDate = (value: unknown) => {
  const raw = text(value);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return "";
  return new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo" }).format(new Date(`${raw}T12:00:00-03:00`));
};

export function notificationContent(notification: Notification, formatMoney: (value: string) => string = brl) {
  const payload = notification.payload;
  if (notification.templateCode === "appointment_assigned") {
    const startsAt = text(payload.startsAt);
    return { title: "Novo serviço na agenda", detail: startsAt ? dateTime(startsAt) : "Horário não informado" };
  }
  if (notification.templateCode === "appointment_rescheduled") {
    const startsAt = text(payload.startsAt);
    return { title: "Serviço reagendado", detail: startsAt ? dateTime(startsAt) : "Consulte a agenda" };
  }
  if (notification.templateCode === "appointment_cancelled") {
    const startsAt = text(payload.startsAt);
    return { title: "Serviço cancelado", detail: startsAt ? dateTime(startsAt) : "Consulte a agenda" };
  }
  if (notification.templateCode === "appointment_reminder_day") {
    const startsAt = text(payload.startsAt);
    return { title: "Serviço amanhã", detail: startsAt ? dateTime(startsAt) : "Consulte a agenda" };
  }
  if (notification.templateCode === "appointment_reminder_hour") {
    const startsAt = text(payload.startsAt);
    return { title: "Serviço em 1 hora", detail: startsAt ? dateTime(startsAt) : "Consulte a agenda" };
  }
  if (notification.templateCode === "appointment_late") {
    const startsAt = text(payload.startsAt);
    return { title: "Serviço ainda não iniciado", detail: startsAt ? dateTime(startsAt) : "Consulte a agenda" };
  }
  if (notification.templateCode === "weekly_schedule_summary") {
    const count = Number(payload.count ?? 0);
    const unassigned = Number(payload.unassignedCount ?? 0);
    return {
      title: "Agenda da semana",
      detail: `${count} serviço${count === 1 ? "" : "s"}${unassigned ? ` · ${unassigned} sem responsável` : ""}`,
    };
  }
  if (notification.templateCode === "quote_accepted") {
    return { title: "Orçamento aceito", detail: text(payload.number) ? `Orçamento ${text(payload.number)}` : "Abra para consultar" };
  }
  if (notification.templateCode === "work_order_started") {
    return { title: "Serviço iniciado", detail: [text(payload.number) ? `OS ${text(payload.number)}` : "", text(payload.serviceName)].filter(Boolean).join(" · ") };
  }
  if (notification.templateCode === "work_order_completed") {
    return { title: "Serviço finalizado", detail: [text(payload.number) ? `OS ${text(payload.number)}` : "", text(payload.serviceName)].filter(Boolean).join(" · ") };
  }
  if (notification.templateCode === "payment_overdue") {
    const amount = text(payload.openAmount);
    return { title: "Pagamento vencido", detail: [civilDate(payload.dueDate), amount ? formatMoney(amount) : ""].filter(Boolean).join(" · ") };
  }
  if (notification.templateCode === "work_order_document_pending") {
    const number = text(payload.number);
    return { title: number ? `OS ${number}` : "Ordem de serviço", detail: "Alerta legado de documentação" };
  }
  if (notification.templateCode === "inventory_below_minimum") {
    return { title: text(payload.materialName) || "Material", detail: `Estoque baixo · ${text(payload.stockLocationName) || "Estoque"}` };
  }
  return { title: `Documento ${text(payload.number) || ""}`.trim(), detail: `Vence em ${civilDate(payload.validUntil) || "breve"}` };
}
